<template>
  <div class="expressEmployeeList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.expressEmployee.employeeRole }}：
          <span v-if="item.EmployeeRole == 1">{{ $t.expressEmployee.role1 }}</span>
          <span v-if="item.EmployeeRole == 2">{{ $t.expressEmployee.role2 }}</span>
          <span v-if="item.EmployeeRole == 3">{{ $t.expressEmployee.role3 }}</span>
        </div>
        <div class="list-item">{{ $t.expressEmployee.surname }}：{{ item.FullName }}</div>
        <div class="list-item">
          {{ $t.expressEmployee.gender }}：
          <span v-if="item.Gender == 1">{{ $t.expressEmployee.male }}</span>
          <span v-if="item.Gender == 2">{{ $t.expressEmployee.female }}</span>
        </div>
        <div class="list-item">
          {{ $t.expressEmployee.idCardNumber }}：{{ item.IdCardNumber }}
        </div>
        <div class="list-item">
          {{ $t.expressEmployee.phoneNumber }}：{{ item.PhoneNumber }}
        </div>
        <div class="list-item">{{ $t.expressEmployee.email }}：{{ item.Email }}</div>
        <div class="list-item">{{ $t.expressEmployee.addUser }}：{{ item.UserName }}</div>
        <div class="list-item">
          {{ $t.expressEmployee.createTime }}：{{ item.CreateTime }}
        </div>
        <div class="list-item">
          {{ $t.expressEmployee.accountActivate }}：
          <span v-if="item.IsActivate == 0">{{ $t.expressEmployee.aStatus1 }}</span>
          <span v-if="item.IsActivate == 1">{{ $t.expressEmployee.aStatus2 }}</span>
        </div>
        <div class="list-item">
          {{ $t.expressEmployee.accountLock }}：
          <span v-if="item.IsLocked == 0">{{ $t.expressEmployee.lStatus1 }}</span>
          <span v-if="item.IsLocked == 1">{{ $t.expressEmployee.lStatus2 }}</span>
        </div>

        <div class="buttons">
          <van-button
            :class="item.IsLocked == '1' ? 'default-btn' : 'search-btn'"
            size="small"
            type="primary"
            @click="handleLock(item)"
          >
            <span v-if="item.IsLocked == '1'">{{ $t.expressEmployee.unlockButton }}</span>
            <span v-else>{{ $t.expressEmployee.lockButton }}</span></van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.EMId)"
            >{{ $t.meta.editButton }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="dialogDeleteShow(item.EMId)"
            >{{ $t.meta.delete }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.expressEmployee.employeeRole }}</div>
        <van-radio-group v-model="employeeRole" direction="horizontal">
          <van-radio :name="1">{{ $t.expressEmployee.role1 }}</van-radio>
          <van-radio :name="2">{{ $t.expressEmployee.role2 }}</van-radio>
          <van-radio :name="3">{{ $t.expressEmployee.role3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.expressEmployee.accountLock }}</div>
        <van-radio-group v-model="accountLock" direction="horizontal">
          <van-radio :name="0">{{ $t.expressEmployee.lStatus1 }}</van-radio>
          <van-radio :name="1">{{ $t.expressEmployee.lStatus1 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.expressEmployee.accountActivate }}</div>
        <van-radio-group v-model="accountActivate" direction="horizontal">
          <van-radio :name="0">{{ $t.expressEmployee.aStatus1 }}</van-radio>
          <van-radio :name="1">{{ $t.expressEmployee.aStatus2 }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteExpressEmployeeInfo"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.expressEmployee.createButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Icon,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Icon)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "expressEmployeeList",
  data() {
    return {
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.expressEmployee.surname,
          value: 1,
        },
        {
          text: this.$t.expressEmployee.phoneNumber,
          value: 2,
        },
      ],
      employeeRole: null,
      accountLock: null,
      accountActivate: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //删除数据
      dialogDeleteId: "",
      showDeleteDialog: false,
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "expressEmployeeDetail",
        name: "expressEmployeeDetail",
        query: [
          {
            name: "EMId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.employeeRole ||
        this.accountLock ||
        this.accountActivate ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.employeeRole = null;
      this.accountLock = null;
      this.accountActivate = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList(page) {
      return new Promise((resolve, reject) => {
        var param = {
          PageIndex: page,
          PageSize: this.pageSize,
          FullName: this.searchType == 1 ? this.searchText : "",
          PhoneNumber: this.searchType == 2 ? this.searchText : "",
          EmployeeRole: this.employeeRole,
          IsLocked: this.accountLock,
          IsActivate: this.accountActivate,
          BeginTime: this.beginTime,
          EndTime: this.endTime,
        };
        this.$api.storage
          .getExpressEmployeeListByPage(param)
          .then((res) => {
            this.tableData = this.tableData.concat(res.data.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
            reject();
          });
      });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    deleteExpressEmployeeInfo() {
      this.$commonMethod.showLoading();
      var param = {
        EMId: this.dialogDeleteId,
      };
      this.$api.storage
        .deleteExpressEmployeeInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleLock(item) {
      this.$commonMethod.showLoading();
      var param = {
        EMId: item.EMId,
        IsLocked: item.IsLocked == "0" ? 1 : 0,
      };
      this.$api.storage
        .updateExpressEmployeeStateByEMId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.expressEmployeeList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
  .taxInvoice-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    .dialog-container {
      padding: 15px;
      font-size: 12px;
      color: #333;
      .dialog-item {
        margin-bottom: 10px;
      }
      .dialog-table {
        .dialog-table-label {
          margin-bottom: 10px;
        }
        .dialog-table-item {
          display: inline-block;
          width: 33.33%;
          text-align: center;
          margin-bottom: 10px;
          .item1 {
            padding: 10px;
            background: #1e90ff;
            color: #ffffff;
          }
          .item2 {
            padding: 10px;
            background: #e8f4ff;
          }
        }
        .dialog-radio-label {
          color: #333;
          margin-bottom: 10px;
          font-size: 12px;
        }
        .dialog-radio-group {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
